import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { PanesPad } from 'modules/core/components/PanesPad'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import IllustratedBlankSlate from 'modules/surveys/components/IllustratedBlankSlate'

import illustration from './illustration.svg'

function ActiveAttendance() {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return (
    <ResponsivePage>
      <ResponsivePage.Body header={{ title: i18n.t('time_tracking.header.title') }}>
        <PanesPad>
          <IllustratedBlankSlate
            illustration={illustration}
            title={i18n.t('honey_pots.active_attendance.title')}
            description={i18n.t('honey_pots.active_attendance.description')}
            linkHref={helpCenterUrl('time_tracking')}
            linkText={i18n.t('honey_pots.active_attendance.more_info')}
            ctaLabel={i18n.t('honey_pots.active_attendance.cta')}
            onClick={() => navigate(navigation.settings.customizations.fullPath())}
          />
        </PanesPad>
      </ResponsivePage.Body>
    </ResponsivePage>
  )
}

export default ActiveAttendance
